import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import BreweryView from '../views/BreweryView.vue';
import BeerView from '@/views/BeerView.vue';
import ReviewViewVue from '@/views/ReviewView.vue';
import LoginView from '../views/LoginView.vue';
import RegisterView from '../views/RegisterView.vue';
import LogoutView from '../views/LogoutView.vue';
import UserReviewView from '../views/UserReviewsView.vue';
import BreweryFormView from '../views/BreweryFormView.vue';
import BeerFormView from '../views/BeerFormView.vue';
import UpdateBeerFormView from '../views/UpdateBeerFormView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: "/brewery/:id",
    name: 'brewery-view',
    component: BreweryView
  },
  {
    path: "/beer/:id",
    name: "Beer",
    component: BeerView
  },
  {
    path: "/newReview/:id",
    name: "review-form",
    component: ReviewViewVue
  },
  {
    path: "/breweryForm",
    name: "brewery-form",
    component:BreweryFormView
  },
  {
    path: "/user/:id",
    name: "UserReviews",
    component: UserReviewView
  },
  {
    path: "/beerForm/:id",
    name: "beer-form-view",
    component: BeerFormView
  },
  {
    path: "/updateBeerForm",
    name: "update-beer-form-view",
    component: UpdateBeerFormView
  },
  {
    path: "/login",
    name: "login-view",
    component: LoginView
  },
  {
    path: "/register",
    name: "register-view",
    component: RegisterView
  },
  {
    path: "/logout",
    name: "logout-view",
    component: LogoutView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
